module.exports = __webpack_public_path__ + "img/razzo-head-page-1.5bbb397b.png";